import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.find";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getDetailByDevNumber, projectList, towerList, stairList, getDeviceByStairsNum, maintenanceHandle } from '@/api/complexManage/mainManage.js';
export default {
  name: 'mainRepair',
  props: {
    DialogVisible2: {
      type: Boolean
    },
    dialogType: {
      type: String
    }
  },
  data: function data() {
    return {
      query: {
        type: '',
        deviceNumber: '',
        projectId: '',
        towerNum: '',
        stairsNum: ''
      },
      searchType: [{
        label: '按空调编号选择',
        value: '0'
      }, {
        label: '按项目选择',
        value: '1'
      }],
      projectOption: [],
      towerIdOption: [],
      elevatorIdOption: [],
      form: {},
      deviceList: [],
      formLabelWidth: '110px'
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  watch: {},
  computed: {},
  methods: {
    init: function init() {
      this.query = {
        type: '',
        deviceNumber: '',
        projectId: '',
        towerNum: '',
        stairsNum: ''
      };
      this.form = new Object();
    },
    // 查询项目列表
    getProjectList: function getProjectList(val) {
      var _this = this;

      if (val == '1') {
        projectList().then(function (res) {
          if (res.data.code == 200) {
            _this.projectOption = res.data.data;
          }
        });
      } else {
        this.query.projectId = '';
        this.query.towerNum = '';
        this.query.stairsNum = '';
      }
    },
    // 根据项目id查询楼号列表
    getTowerList: function getTowerList(projectId) {
      var _this2 = this;

      var val = this.projectOption.find(function (item) {
        return item.projectId == projectId;
      });
      this.query.towerNum = '';
      this.query.stairsNum = '';
      this.towerIdOption = [];
      this.elevatorIdOption = [];
      this.form = {
        projectId: val.projectId,
        projectName: val.projectName,
        province: val.province,
        city: val.city,
        area: val.area,
        address: val.address,
        deviceList: this.deviceList
      };
      var obj = {
        projectId: val.projectId
      };
      towerList(obj).then(function (res) {
        if (res.data.code == 200) {
          _this2.towerIdOption = res.data.data;
        }
      });
    },
    // 根据楼号查询梯号列表
    getstairList: function getstairList(towerNum) {
      var _this3 = this;

      var val = this.towerIdOption.find(function (item) {
        return item.towerNum == towerNum;
      });
      this.query.stairsNum = '';
      this.elevatorIdOption = [];
      var params = {
        projectId: val.projectId,
        towerNum: val.towerNum
      };
      stairList(params).then(function (res) {
        _this3.elevatorIdOption = [];

        if (res.data.code == 200) {
          var _iterator = _createForOfIteratorHelper(res.data.data),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              var obj = {
                label: item.stairsNum,
                value: item.stairsNum
              };

              _this3.elevatorIdOption.push(obj);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      });
    },
    add: function add() {
      var _this4 = this;

      var params = {};
      var val = this.projectOption.find(function (item) {
        return item.projectId == _this4.query.projectId;
      });

      if (this.query.type == '0') {
        getDetailByDevNumber({
          deviceNumber: this.query.deviceNumber
        }).then(function (res) {
          if (res.data.code == 200) {
            if (JSON.stringify(res.data.data) != "{}") {
              var _res$data$data = res.data.data,
                  deviceId = _res$data$data.deviceId,
                  devNumber = _res$data$data.devNumber,
                  towerNumber = _res$data$data.towerNumber,
                  stairsNumber = _res$data$data.stairsNumber,
                  projectName = _res$data$data.projectName,
                  elevatorBrand = _res$data$data.elevatorBrand;
              var obj = {
                deviceId: deviceId,
                devNumber: devNumber,
                towerNumber: towerNumber,
                stairsNumber: stairsNumber,
                projectName: projectName,
                elevatorBrand: elevatorBrand,
                repairReason: ''
              };
              _this4.form = {
                projectId: res.data.data.projectId,
                projectName: res.data.data.projectName,
                province: res.data.data.province,
                city: res.data.data.city,
                area: res.data.data.area,
                address: res.data.data.address
              };

              _this4.deviceList.push(obj);
            } else {
              _this4.$message.error(res.data.msg);
            }
          }
        });
      } else {
        var _this$query = this.query,
            towerNum = _this$query.towerNum,
            stairsNum = _this$query.stairsNum;
        params = {
          projectId: this.form.projectId,
          towerNum: towerNum,
          stairsNum: stairsNum
        };
        getDeviceByStairsNum(params).then(function (res) {
          if (res.data.code == 200) {
            var _res$data$data2 = res.data.data,
                deviceId = _res$data$data2.deviceId,
                devNumber = _res$data$data2.devNumber,
                _res$data$data2$tower = _res$data$data2.towerNumber,
                towerNumber = _res$data$data2$tower === void 0 ? _this4.query.towerNum : _res$data$data2$tower,
                _res$data$data2$proje = _res$data$data2.projectName,
                projectName = _res$data$data2$proje === void 0 ? val.projectName : _res$data$data2$proje,
                _res$data$data2$stair = _res$data$data2.stairsNumber,
                stairsNumber = _res$data$data2$stair === void 0 ? _this4.query.stairsNumber : _res$data$data2$stair,
                elevatorBrand = _res$data$data2.elevatorBrand;
            var obj = {
              deviceId: deviceId,
              devNumber: devNumber,
              towerNumber: towerNumber,
              stairsNumber: stairsNumber,
              projectName: projectName,
              elevatorBrand: elevatorBrand,
              repairReason: ''
            };

            _this4.deviceList.push(obj);
          }
        });
      }
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      if (this.deviceList.length < 1) {
        this.$message.error("请先进行填报");
        return;
      }

      this.form.deviceList = this.deviceList;
      maintenanceHandle(this.form).then(function (res) {
        if (res.data.code == 200) {
          _this5.$message.success(res.data.msg);

          _this5.close();
        }
      });
    },
    close: function close() {
      this.init();
      this.deviceList = [];
      this.$emit('close2', false);
    }
  }
};